import * as v from "valibot";
import { rpcContract } from "../rpc";

export const endLiveEventRpcContract = rpcContract({
  name: "end-live-event",
  paramsSchema: v.object({
    event_id: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.optional(v.string()),
  }),
});

export type EndLiveEventParams = v.InferOutput<(typeof endLiveEventRpcContract)["paramsSchema"]>;
export type EndLiveEventResult = v.InferOutput<(typeof endLiveEventRpcContract)["resultSchema"]>;
